import React from 'react';
import {
  Box,
  Skeleton,
  Grid,
  Card,
  CardContent,
  useTheme,
} from '@mui/material';

const LoadingSkeleton = ({ 
  type = 'card', 
  count = 4, 
  columns = 4, 
  height = 300,
  showTitle = true,
  titleWidth = '30%',
  ...props 
}) => {
  const theme = useTheme();

  const renderCardSkeleton = () => (
    <Card sx={{ height: '100%' }}>
      <Skeleton variant="rectangular" width="100%" height={height} />
      <CardContent sx={{ pb: 1 }}>
        <Skeleton variant="text" width="80%" height={24} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="60%" height={20} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="40%" height={24} />
      </CardContent>
    </Card>
  );

  const renderRectangularSkeleton = () => (
    <Skeleton 
      variant="rectangular" 
      width="100%" 
      height={height} 
      sx={{ 
        borderRadius: 2,
        bgcolor: theme.palette.mode === 'dark' ? 'grey.800' : 'grey.200' 
      }} 
    />
  );

  const renderTextSkeleton = () => (
    <Skeleton 
      variant="text" 
      width={titleWidth} 
      height={40} 
      sx={{ 
        mx: 'auto',
        bgcolor: theme.palette.mode === 'dark' ? 'grey.800' : 'grey.200' 
      }} 
    />
  );

  const renderSkeleton = () => {
    switch (type) {
      case 'hero':
        return renderRectangularSkeleton();
      case 'banner':
        return renderRectangularSkeleton();
      case 'title':
        return renderTextSkeleton();
      case 'card':
      default:
        return renderCardSkeleton();
    }
  };

  return (
    <Box sx={{ py: 6, ...props.sx }}>
      {showTitle && renderTextSkeleton()}
      <Grid container spacing={3}>
        {[...Array(count)].map((_, index) => (
          <Grid item xs={12 / columns} key={index}>
            {renderSkeleton()}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default LoadingSkeleton;
